import { render } from "./slide-funcionarios.vue?vue&type=template&id=18c2806a"
import script from "./slide-funcionarios.js?vue&type=script&lang=js&external"
export * from "./slide-funcionarios.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__